<template>
	<div>
		<v-content>
			<v-container fluid>
        <v-layout row wrap>
              <center style="width: 100%;"><img class="imgLoader" src="../shared/assets/images/3dloader.gif" v-if="stockLoaded == false" /></center>
          <v-flex lg8 v-if="pricingTable != '' && stockLoaded == true">
          </v-flex>
          <v-flex lg1 v-if="pricingTable != '' && stockLoaded == true">
            <v-btn color="success" class="text-xs-right" @click="fncUpdateStock">Update Stock</v-btn>
          </v-flex>
          <v-flex lg1 v-if="pricingTable != '' && stockLoaded == true">
            <v-btn color="success" class="text-xs-right" @click="fncDownloadCsv">Download CSV</v-btn>
          </v-flex>
          <v-flex lg2 style="padding-left: 1%" v-if="pricingTable != '' && stockLoaded == true">
            <small style="font-size:10px;display:block;clear:both;">Bulk Upload</small>
            <input style="margin-top:0px;width:200px;display: block; float:left" type="file" @input="fncSetStock" />
            <!--<v-btn color="success" class="text-xs-right">Upload CSV</v-btn>-->
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="stockLoaded == true">
          <v-flex lg12>
            <small><strong>Please select a pricing table to update the stock levels for:</strong></small>
            <v-select :items="pricingTables" v-model="pricingTable" @input="fncShowDataTable" placeholder="Select Pricing Table" class="dropdown" item-value="pricing_table" item-text="pricing_table" solo outline></v-select>
          </v-flex>
        </v-layout>
        <!-- datatable__actions -->
				<v-data-table :rows-per-page-items="[100000]" id="stockTable" v-if="pricingTable != '' && stockLoaded == true" :headers="headers" :search="search" :items="codesList" class="elevation-1">
					<template slot="items" slot-scope="props">
						<td width="20%" class="text-xs-right">{{ props.item.code }}</td>
						<td width="30%" class="text-xs-right">{{ props.item.name }}</td>
						<td width="20%" class="text-xs-right">{{ props.item.quantity }}</td>
            <td width="30%" class="text-xs-right"><v-text-field style="width: 80%; display: inline-block; float:left;" v-model="props.item.new_quantity" solo single-line></v-text-field><span style="float: left; margin-left: 1%; padding-top: 10px; display: inline-block;">{{ props.item.uom }}</span></td>
					</template>
				</v-data-table>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';
  import Stock from "../../store/modules/stock";

  export default {
	name: 'PrivList',
    data () {
		return {
			search: '',
      pricingTable: '',
      codesList: [],
			headers: [
				{ text: 'Codes', value: 'code', width: '20%' },
        { text: 'Description', value: 'current_price', width: '30%' },
        { text: 'Current Stock', value: 'current_price', width: '20%' },
        { text: 'New Stock', value: 'new_price', width: '30%' }
      ],
      hasDefaultError: true
		}
	},
    methods: {
      fncDownloadCsv() {

        var csvData = [];

        for( var s in this.codesList ) {
          csvData.push({ code: this.codesList[s].code, stock: this.codesList[s].new_quantity, name: this.codesList[s].name })
        }

        this.$store.dispatch('fncDownloadStockCsv', csvData);

      },
      fncUpdateStock() {
        this.$store.dispatch('fncUpdateStock', this.codesList);
      },
      fncShowDataTable() {

        var refArray = [];
        for( var s in this.savedStock ) {
          refArray[String(this.savedStock[s].code)] = parseInt(this.savedStock[s].stock_level);
        }

        this.codesList = [];
        for( var s in this.stockData ) {
          if( this.stockData[s].pricing_table == this.pricingTable ) {

            this.stockData[s].quantity = refArray[String(this.stockData[s].code)] != undefined ? refArray[String(this.stockData[s].code)] : 0;
            this.stockData[s].new_quantity = refArray[String(this.stockData[s].code)] != undefined ? refArray[String(this.stockData[s].code)] : 0;

            this.codesList.push(this.stockData[s]);
          }
        }
      },
      fncSetStock(e) {

        var files = e.target.files || e.dataTransfer.files;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          var plistResult = reader.result;

          var splitRows = plistResult.split("\n");

          var objStock = [];

          if (splitRows.length != 0) {
            for (var r in splitRows) {

              if (r != 0) {
                if( splitRows[r] != '' ) {
                  var rowSplit = splitRows[r].split(',');

                  var stockSplit = rowSplit[2].split("\r");

                  objStock[rowSplit[0]] = stockSplit[0];
                }
              }
            }

            for( var c in vm.codesList ) {
              if( objStock[vm.codesList[c].code] != undefined ) {
                vm.codesList[c].new_quantity = objStock[vm.codesList[c].code];
              }

            }
          }
        }
        reader.readAsText(files[0]);
      }
	},
    watch: {
	    stockData() {
	      console.log('test');
      }
    },
	computed: {
		...mapGetters([
			'objAuthorize',
			'stockData',
			'pricingTables',
			'savedStock',
      'stockLoaded'
		])
	},
	beforeMount() {
    this.$store.dispatch('fncPopulateSavedStock');
		this.$store.dispatch('fncPopulatePricingTableStock');
	},
  mounted() {


  },
	created() {
		/*if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') === -1 ) {
			this.headers = [
				{ text: 'Name', value: 'pl_name' },
				{ text: 'Description', value: 'pl_description' },
				{ text: 'Active', value: 'pl_active' },
				{ text: 'Revision', value: 'pl_revision' },
				{ text: 'Default', value: 'pl_is_default' },
				{ text: 'Cost List', value: 'pl_is_cost' },
				{ text: 'Modified On', value: 'pl_modified' }
			]
        }
        if (this.pricelistList != '' ) {
          this.loaded = true
        }*/
    }
}
</script>

<style scoped>

</style>
